import { EmailInbox } from './EmailInbox';

export default function OutgoingEmails(props) {
  return (<EmailInbox inboxType="outgoing" props={props}/>)
}
